import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { PaymentExecutionStatus } from '../../services/dto/payment-execution-status';

export const paymentExecutionStatusLabel = (paymentExecutionStatus: PaymentExecutionStatus) =>
  `project.paymentExecutionStatus.${PaymentExecutionStatus[paymentExecutionStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-payment-execution-status',
  templateUrl: './payment-execution-status.component.html',
  styleUrl: './payment-execution-status.component.scss',
  imports: [BadgeComponent, TranslatePipe],
})
export class PaymentExecutionStatusComponent extends CamBaseComponent {
  status = input.required<number | PaymentExecutionStatus>();

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  public label() {
    return paymentExecutionStatusLabel(this.status());
  }

  public type() {
    switch (this.status()) {
      case PaymentExecutionStatus.HighRisk:
        return 'orange';
      case PaymentExecutionStatus.ThresholdExceeded:
        return 'orange';
      case PaymentExecutionStatus.Planned:
        return 'info';
      case PaymentExecutionStatus.Executed:
        return 'success';
      case PaymentExecutionStatus.Error:
        return 'danger';
      case PaymentExecutionStatus.Na:
      default:
        return 'default';
    }
  }
}
